import { type ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '#/lib/utils';

interface TooltipProps {
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export function Tooltip({ children, position = 'top' }: TooltipProps) {
  return (
    <TooltipPrimitive.Provider delayDuration={50}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center "
          >
            <TooltipIcon />
          </button>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={position}
            sideOffset={4}
            className={cn(
              'z-20 max-w-sm overflow-hidden rounded-10 bg-grayscale-02 p-10 text-charcoal TooltipContent',
            )}
          >
            {children}
            <TooltipPrimitive.Arrow
              className="fill-grayscale-02"
              width={14}
              height={6}
            />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}

export function TooltipIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="text-neutral-500" // Adjusted color to match image (approx.)
    >
      <circle
        cx="9.67508"
        cy="10.2332"
        r="7.26004"
        stroke="currentColor"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="9.67508"
        cy="10.2332"
        r="7.26004"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.86719 13.0567H10.7301"
        stroke="currentColor"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.86719 13.0567H10.7301"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.80267 13.0565V9.62817H8.875"
        stroke="currentColor"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.80267 13.0565V9.62817H8.875"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75539 7.20607C9.75539 7.31745 9.6651 7.40774 9.55373 7.40774C9.44235 7.40774 9.35206 7.31745 9.35206 7.20607C9.35206 7.09469 9.44235 7.0044 9.55373 7.0044"
        stroke="currentColor"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75539 7.20607C9.75539 7.31745 9.6651 7.40774 9.55373 7.40774C9.44235 7.40774 9.35206 7.31745 9.35206 7.20607C9.35206 7.09469 9.44235 7.0044 9.55373 7.0044"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.55348 7.00441C9.66486 7.00441 9.75515 7.0947 9.75515 7.20607"
        stroke="currentColor"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.55348 7.00441C9.66486 7.00441 9.75515 7.0947 9.75515 7.20607"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.2095"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
